export const GoogleMapApiConfig = 'AIzaSyCmVAGkkWaaq2YC0k8jQ6245Up6K1E9Tr4';